import { render, staticRenderFns } from "./phone-input.vue?vue&type=template&id=0fb7f3f2&"
import script from "./phone-input.vue?vue&type=script&lang=js&"
export * from "./phone-input.vue?vue&type=script&lang=js&"
import style0 from "./phone-input.vue?vue&type=style&index=0&id=0fb7f3f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzLangSwitcher: require('/opt/airport.kg/node_modules/razlet-ui/src/components/lang-switcher/index.vue').default})
